export const FIND_PROCESS_STATEMENT_RESULTS_FAILURE = 'FIND_PROCESS_STATEMENT_RESULTS_FAILURE';

export const findProcessStatementResultsFailure = error => ({
    type: FIND_PROCESS_STATEMENT_RESULTS_FAILURE,
    payload: error,
    error: true,
});
